module.exports = __webpack_public_path__ + "static/img/headerFooterOff.ebe23397.svg";